module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marker-window"
  }, [_c('v-btn', {
    staticClass: "window-input",
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.lat) + "," + _vm._s(_vm.lng))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df58ecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/new/MarkerWindow.vue
// module id = 777
// module chunks = 23